import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[allow_10_2_Decimal]',
})
export class TenDigitDecimaNumberDirective {
  private regex: RegExp = new RegExp(/^(\d[0-9]{0,9})?(\.[0-9]{0,2})?$/g);

  private specialKeys: Array<string> = [
    'Backspace',
    'Tab',
    'End',
    'Home',
    'ArrowLeft',
    'ArrowRight',
    'Del',
    'Delete',
  ];

  constructor(private el: ElementRef) {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): any {
    if (event.key === '-') {
      event.preventDefault();
      return;
    }
    // Allow Backspace, tab, end, and home keys
    if (
      this.specialKeys.indexOf(event.key) !== -1 ||
      (event.key === 'v' && event.ctrlKey === true) ||
      (event.key === 'c' && event.ctrlKey === true) ||
      (event.key === 'a' && event.ctrlKey === true)
    ) {
      return;
    }
    const current: string = this.el.nativeElement.value;
    const position = this.el.nativeElement.selectionStart;
    const next: string = [
      current.slice(0, position),
      event.key === 'Decimal' ? '.' : event.key,
      current.slice(position),
    ].join('');
    if (next && !String(next).match(this.regex)) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    const pastedValue = event.clipboardData?.getData('text');
    if (pastedValue && !String(pastedValue).match(this.regex)) {
      event.preventDefault();
    }
  }
}
